import { ValidateJSModel } from 'forms/shared/types';
import foreignBornDocumentTypes from 'constants/enums/foreignBornDocumentTypes';
import foreignBornSF85PDocumentTypes from 'constants/enums/foreignBornSF85PDocumentTypes';
import * as formTypes from 'constants/formTypes';
import { lettersAndNumbersPattern } from 'constants/patterns';
import { RelationshipsSharedForeignBornDocumentModel } from './types';

const relationshipsSharedForeignBornDocumentValidator: ValidateJSModel<RelationshipsSharedForeignBornDocumentModel> = {
  DocumentExpirationNotApplicable: {},
  Comments: {},

  DocumentType: (value, attributes, attributeName, options) => ({
    presence: true,
    hasValue: {
      validator: {
        inclusion:
            [formTypes.SF85P, formTypes.SF85PS].includes(options?.formType || '') ? foreignBornSF85PDocumentTypes : foreignBornDocumentTypes,
      },
    },
  }),

  OtherExplanation: (value, attributes) => {
    if (attributes.DocumentType?.value === 'Other') {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },

  DocumentExpiration: (value, attributes, attributeName, options) => {
    if (attributes.DocumentExpirationNotApplicable?.applicable === false
          && (options?.formType !== formTypes.SF86 || !['I-551',
            'I-766',
            'I-94',
            'Visa',
            'NonImmigrantStudent',
            'ExchangeVisitor',
          ].includes(attributes.DocumentType?.value ?? 'None'))) { return {}; }

    if (options.requireForeignBornDocExpiration) {
      return {
        presence: true,
        date: options.spouseBirthdate ? {
          requireYear: false,
          earliest: (options.spouseBirthdate),
          tooEarly: 'relationships.marital.errors.documentExpiration.tooEarly',
        } : {
          requireYear: false,
          earliest: (options.tooEarly),
          tooEarly: 'relationships.marital.errors.documentExpiration.tooEarly',
        }
      };
    }

    return {};
  },

  DocumentNumber: {
    presence: true,
    hasValue: {
      validator: {
        format: {
          pattern: lettersAndNumbersPattern,
          message: 'error.alphanumeric.pattern',
        },
        length: {
          maximum: 30,
          message: 'error.maximumLength',
        },
      },
    },
  },
};

export default relationshipsSharedForeignBornDocumentValidator;
